import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { IconesModalComponent } from 'src/app/modals/icones-modal/icones-modal.component';
import { TagGi } from 'src/app/models/tag-gi';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { TagGiService } from 'src/app/services/tag-gi.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';

@Component({
  selector: 'app-cadastrar-tag-gi',
  templateUrl: './cadastrar-tag-gi.component.html',
  styleUrls: ['./cadastrar-tag-gi.component.scss']
})
export class CadastrarTagGiComponent implements OnInit {
  // variáveis
  idTagGi = '';
  tag = new TagGi();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;
  tipoSelecionado = 0;

  tiposVinculo: any[] = [{ id: 0, nome: 'Normal' }, { id: 1, nome: 'Comprovante de Pagamento' }];

  constructor(private route: ActivatedRoute, private notificacaoService: NotificacaoService,
    private tagService: TagGiService, public dialog: MatDialog,
    private router: Router, private viaCepService: ViaCepService,
    private globalService: GlobalService, private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.tipoSelecionado = this.router.getCurrentNavigation().extras.state.tipo;
    }
  }

  ngOnInit() {

    // se for edição, busca o tag do id passado
    if (this.route.snapshot.paramMap.get('id')) {
      this.idTagGi = this.route.snapshot.paramMap.get('id');
      this.editando = true;
      this.buscarTagGi();
    } else {
      this.tag = new TagGi();
      this.atualizaDadosTagGi();
    }
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarTagGi() {

    this.carregandoService.mostra('buscaTagGi');

    this.tagService.consultarPorIdTag(this.idTagGi).subscribe(tipo => {
      this.tag = tipo;
      this.atualizaDadosTagGi();
    }, (erro) => {
      this.carregandoService.esconde('buscaTagGi');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosTagGi() {

    this.carregando = false;

    this.carregandoService.esconde('buscaTagGi');
  }

  salvar() {
    this.carregandoService.mostra('salvaTagGi');

    this.tag.tipo = this.tipoSelecionado;

    this.tagService.salvar(this.tag).subscribe(() => {
      this.notificacaoService.sucesso('Tag salva com sucesso!!!');
      this.router.navigate(['/configuracoes/tags'], { state: { tipo: this.tipoSelecionado } }).then(() => {
        this.carregandoService.esconde('salvaTagGi');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaTagGi');
      this.notificacaoService.erro(erro);
    });
  }

  selecionarIcone() {


    const dialogRef = this.dialog.open(IconesModalComponent, {
      // width: ($('body').width()).toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.tag.icone = result;
      }
    });
  }


  ngOnDestroy(): void {

  }
}
